import React, {useCallback, memo } from "react";
import { Spinner } from "react-bootstrap";
import {
  formatStatus,
  formatImage,
  formatProdInfo,
  formatActionsWithAnalytics
} from "../../../components/Formatters";


const SummaryTableCardComponent = ({
  totalRecords,
  tableSearch,
  setTableSearch,
  setAppliedSearch,
  setCurrentPage,
  loadingTable,
  activeColumns,
  activeRows,
  rangeStart,
  rangeEnd,
  currentPage,
  totalPages,
  pageNumbers,
  isMobile,
  tableType,
  onOpenAnalytics
}) => {

  const renderTableCell = useCallback((key, row) => {
    switch (key) {
      case "actions":
        return formatActionsWithAnalytics(row, onOpenAnalytics);
      case "status":
        return formatStatus(row[key]);
      case "img":
        return formatImage(row[key]);
      case "asin":
        return formatProdInfo(row);
      default:
        return row[key] ?? "-";
    }
  }, []);

  return (
    <div className="card view">
      <div className="card-body">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2 mb-3 table-toolbar">
          <h6 className="mb-0">Total: {totalRecords}</h6>

          <div
            className="d-flex gap-2 table-toolbar-actions"
            style={{ maxWidth: 420, width: "100%" }}
          >
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Search..."
              value={tableSearch}
              onChange={(e) => setTableSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setCurrentPage(1);
                  setAppliedSearch(tableSearch.trim());
                }
              }}
            />

            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={() => {
                setTableSearch("");
                setAppliedSearch("");
                setCurrentPage(1);
              }}
            >
              Reset
            </button>
          </div>
        </div>

        <div
          className={`table-responsive position-relative summary-table-wrapper ${
            loadingTable ? "loading" : ""
          }`}
        >
          {loadingTable && (
            <div className="summary-table-loading">
              <Spinner animation="grow" variant="secondary" />
              <div className="mt-2">Loading data...</div>
            </div>
          )}

          <table className="table table-sm table-striped table-hover align-middle mb-0">
            <thead>
              <tr>
                {tableType=="listings" && (
                    <th>Actions</th>
                  )}
                {activeColumns.map((column) => (
                  <th key={column.key}>{column.label}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {activeRows.length > 0 ? (
                activeRows.map((row) => (
                  <tr key={row.id}>
                   {tableType=="listings" && (
                     <td className="actions">
                       {renderTableCell('actions', row)}
                     </td>
                    )}

                    {activeColumns.map((column) => (
                      <td className={column.key} key={column.key}>
                        {renderTableCell(column.key, row)}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={activeColumns.length || 1}
                    className="text-center text-muted"
                  >
                    No data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2 mt-3">
          <small className="text-muted">
            Showing {rangeStart}-{rangeEnd} of {totalRecords}
          </small>

          <nav aria-label="Summary table pagination">
            <ul className="pagination pagination-sm mb-0">
              <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button
                  type="button"
                  className="page-link"
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(1, prev - 1))
                  }
                >
                  Previous
                </button>
              </li>

              {isMobile ? (
                <li className="page-item active">
                  <span className="page-link">
                    {currentPage} / {totalPages}
                  </span>
                </li>
              ) : (
                pageNumbers.map((page) => (
                  <li
                    key={page}
                    className={`page-item ${currentPage === page ? "active" : ""}`}
                  >
                    <button
                      type="button"
                      className="page-link"
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </button>
                  </li>
                ))
              )}

              <li
                className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
              >
                <button
                  type="button"
                  className="page-link"
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(totalPages, prev + 1))
                  }
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

const SummaryTableCard = memo(SummaryTableCardComponent);

export default SummaryTableCard;
